import React, { useState, useEffect } from 'react';
import { Modal } from 'react-responsive-modal';
import LoggingService from '../Services/LoggingService';

const TermsAndConditionsModal = () => {
    const [ isModalOpen, setIsModalOpen ] = useState( false );
    const [ modalContent, setModalContent ] = useState( '' );
    const [ modalTitle, setModalTitle ] = useState( '' );

    const openModal = () => {
        const termsAndConditionsContent = document.querySelector( '.woocommerce-terms-and-conditions' );
        
        if ( termsAndConditionsContent ) {
            setModalTitle( 'Terms & Conditions' );
            setModalContent( termsAndConditionsContent.innerHTML );
            setIsModalOpen( true );
        } else {
            LoggingService.logError( 'Terms and conditions content not found' );
        }
    };

    useEffect( () => {
        const termsAndConditionsLink = document.querySelector( '.woocommerce-terms-and-conditions-link' );
        
        if ( termsAndConditionsLink ) {
            const handleClick = ( e ) => {
                e.preventDefault();
                openModal();
            };
            
            termsAndConditionsLink.addEventListener( 'click', handleClick );
            
            return () => {
                termsAndConditionsLink.removeEventListener( 'click', handleClick );
            };
        }
    }, [] );

    return (
        <>
            {isModalOpen && (
                <Modal
                    open={true}
                    onClose={() => setIsModalOpen( false )}
                    focusTrapped={false}
                    classNames={{
                        overlay: 'cfw-modal-overlay',
                        modal: 'cfw-modal',
                        root: 'cfw-modal-root',
                        modalContainer: 'cfw-modal-container',
                    }}
                >
                    <h1>{modalTitle}</h1>
                    <div dangerouslySetInnerHTML={{ __html: modalContent }} />
                </Modal>
            )}
        </>
    );
};

export default TermsAndConditionsModal;